import  * as component  from './components'

/*
const children = [{
  name: 'create.description',
  path: '/campaign/description/:id',
  component: component.description,
  meta: { requiresAuth: false },
}
]  */

export default [
    {
      name: 'report.campaignsnew',
      path: '/report/campaignsnew',
      component: component.ReportingNew,
      meta: { requiresAuth: true },
    },
    {
      name: 'report.campaigns',
      path: '/report/campaigns',
      component: component.ReportingsNew
     },
     {
      name: 'report.allcampaigns',
      path: '/report/allcampaigns',
      component: component.ReportingsNew
     },
     {
      name: 'report.allannouncements',
      path: '/report/allannouncements',
      component: component.ReportingsNew
     },
     {
      name: 'report.campaigns.new',
      path: '/report/campaigns/new',
      component: component.ReportingsNew
     },
     {
      name: 'report.repeatAffender',
      path: '/report/repeatAffender',
      component: component.RepeatAffender
     },
     {
      name: 'report.campaignreporting',
      path: '/report/campaigns/:id',
      // component: component.campaignReporting
      component: component.campaignReportingNew
     },

     {
      name: 'report.comparereporting',
      path: '/report/compare/:id',
      // component: component.campaignReporting
      component: component.compareReportingNew
      },
      {
      name: 'report.campaignreporting.new',
      path: '/report/campaigns/new/:id',
      component: component.campaignReportingNew
     },
     {
      name: 'report.recipientlisting',
      //path: '/report/campaigns/:id/:type?name',
      path: '/report/campaigns/:id/:type',
      component: component.recipientListing
     },
     {
      name: 'report.detailedreporting',
      path: '/report/detailed',
      component: component.campaignDetailedReporting
     },
     {
        name: 'report.hcsa',
        path: '/report/hcsa_hisp',
        component: component.hcsa
     },
     {
      name: 'report.campaignreportingScenario',
      path: '/scenarioreport/campaigns',
      component: component.campaignReportingScenario
     },
    /* {
      name: 'report.recipientprofile',
      path: '/report/recepients/:tid',
      component: component.recipientProfile
     }, */
   /* {
      children,
      name: 'create.index',
      path: '/create',
      component: component.createCampaignMain,
      redirect: { name: 'create.scenario' },
      meta: { requiresAuth: false },
    } */
]



// WEBPACK FOOTER //
// ./src/app/report/routes/index.js